(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-logo-bar"] && !Shopify.designMode) return;
  try {
    
  // Drive the duration off the measured track width so both rows move at the SAME
  // pixels per second even though they hold different logos, and so the loop stays
  // seamless if logos are added or removed later.
  (() => {
    const setDurations = (root) => {
      const speed = parseFloat(root.dataset.speed) || 50;
      root.querySelectorAll('[data-mc-logos-track]').forEach((track) => {
        const set = track.querySelector('[data-mc-logos-set]');
        if (!set) return;
        const width = set.getBoundingClientRect().width;
        if (!width) return;
        track.style.setProperty('--mc-logos-dur', `${(width / speed).toFixed(2)}s`);
      });
    };

    // On mobile the bar is asked to sit ABOVE the industry list rather than after the
    // whole section, and sections cannot be interleaved from Liquid. So below the
    // breakpoint the element is moved next to the block named by data-move-before and
    // its now-empty section is collapsed; above the breakpoint it goes back. A comment
    // node holds its original position.
    const BREAKPOINT = 749;
    const relocate = () => {
      document.querySelectorAll('[data-mc-logos][data-move-before]').forEach((root) => {
        if (!root.__mcHome) {
          root.__mcHome = document.createComment('mc-logos-home');
          root.parentNode.insertBefore(root.__mcHome, root);
        }
        const section = root.closest('.shopify-section') || root.__mcHome.parentNode;
        const wantsMobile = window.matchMedia(`(max-width: ${BREAKPOINT}px)`).matches;
        const found = document.querySelector(root.dataset.moveBefore);
        const anchor = found ? found.closest('.group-block') || found : null;

        if (wantsMobile && anchor && root.parentNode !== anchor.parentNode) {
          anchor.parentNode.insertBefore(root, anchor);
          root.classList.add('mc-logos--relocated');
          if (section) section.classList.add('mc-logos-section--relocated');
        } else if (!wantsMobile && root.parentNode !== root.__mcHome.parentNode) {
          root.__mcHome.parentNode.insertBefore(root, root.__mcHome);
          root.classList.remove('mc-logos--relocated');
          if (section) section.classList.remove('mc-logos-section--relocated');
        }
      });
    };

    const init = () => {
      relocate();
      document.querySelectorAll('[data-mc-logos]').forEach((root) => {
        setDurations(root);
        // Images are lazy: a logo that lands after first paint changes the set width.
        root.querySelectorAll('img').forEach((img) => {
          if (!img.complete) img.addEventListener('load', () => setDurations(root), { once: true });
        });
      });
    };

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(init, 200);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-photo-row"] && !Shopify.designMode) return;
  try {
    
  /* Cross-fades mc-photo-row frames and wires dot navigation. Clicking a dot hands control to
     the visitor and stops the timer for good. */
  (function () {
    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var INTERVAL = 7200;   /* hold 5850ms after the 1.35s fade */

    document.querySelectorAll('.mc-photo-row__media').forEach(function (media) {
      var frames = media.querySelectorAll('.mc-photo-row__img--stacked');
      var dots = media.querySelectorAll('[data-mc-dot]');
      if (frames.length < 2) return;

      var i = 0;
      var timer = null;
      var userTookOver = false;

      /* Swap a deferred frame's data-src into src the first time it is needed. */
      function promote(el) {
        if (!el || !el.dataset.src) return;
        el.src = el.dataset.src;
        if (el.dataset.srcset) el.srcset = el.dataset.srcset;
        delete el.dataset.src;
        delete el.dataset.srcset;
      }

      function show(next) {
        var prev = i;
        frames[i].classList.remove('is-active');
        if (dots[i]) {
          dots[i].classList.remove('is-active');
          dots[i].removeAttribute('aria-current');
        }
        i = (next + frames.length) % frames.length;
        promote(frames[i]);
        promote(frames[(i + 1) % frames.length]);   /* have the next one ready to fade to */
        frames[i].classList.add('is-active');
        /* Without this the visible frame stays aria-hidden with an empty alt while the hidden
           frame 1 keeps the description. */
        frames[i].removeAttribute('aria-hidden');
        if (prev !== i) frames[prev].setAttribute('aria-hidden', 'true');
        if (dots[i]) {
          dots[i].classList.add('is-active');
          dots[i].setAttribute('aria-current', 'true');
        }
      }

      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          userTookOver = true;
          stop();
          show(parseInt(dot.getAttribute('data-mc-dot'), 10));
        });
      });

      if (REDUCED) return;

      function start() {
        if (!timer && !userTookOver) timer = setInterval(function () { show(i + 1); }, INTERVAL);
      }

      /* Swapping the photo out from under someone who has deliberately hovered to look at it is
         the single rudest thing this component did. */
      media.addEventListener('mouseenter', function () { if (!userTookOver) stop(); });
      media.addEventListener('mouseleave', function () { start(); });
      media.addEventListener('focusin', function () { stop(); });

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            start();
          } else {
            stop();
          }
        });
      }, { rootMargin: '0px', threshold: 0.4 });

      io.observe(media);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-work-grid"] && !Shopify.designMode) return;
  try {
    
  /* Cross-fades work-card frames and wires the dot navigation.
     Auto-rotation stops for good once the visitor clicks a dot - taking manual control should
     not be fought by a timer moving the image out from under them. */
  (function () {
    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var INTERVAL = 6400;   /* hold 5200ms after the 1.2s fade */

    document.querySelectorAll('.mc-work-card__media[data-mc-rotate]').forEach(function (media) {
      var frames = media.querySelectorAll('.mc-work-card__img');
      var dots = media.querySelectorAll('[data-mc-dot]');
      if (frames.length < 2) return;

      var i = 0;
      var timer = null;
      var userTookOver = false;

      /* Swap a deferred frame's data-src into src the first time it is needed. */
      function promote(el) {
        if (!el || !el.dataset.src) return;
        el.src = el.dataset.src;
        if (el.dataset.srcset) el.srcset = el.dataset.srcset;
        delete el.dataset.src;
        delete el.dataset.srcset;
      }

      function show(next) {
        var prev = i;
        frames[i].classList.remove('is-active');
        if (dots[i]) {
          dots[i].classList.remove('is-active');
          dots[i].removeAttribute('aria-current');
        }
        i = (next + frames.length) % frames.length;
        promote(frames[i]);
        promote(frames[(i + 1) % frames.length]);   /* have the next one ready to fade to */
        frames[i].classList.add('is-active');
        /* Without this the visible frame stays aria-hidden with an empty alt while the hidden
           frame 1 keeps the description. */
        frames[i].removeAttribute('aria-hidden');
        if (prev !== i) frames[prev].setAttribute('aria-hidden', 'true');
        if (dots[i]) {
          dots[i].classList.add('is-active');
          dots[i].setAttribute('aria-current', 'true');
        }
      }

      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          userTookOver = true;
          stop();
          show(parseInt(dot.getAttribute('data-mc-dot'), 10));
        });
      });

      /* Reduced motion: dots still work, nothing moves on its own. */
      if (REDUCED) return;

      function start() {
        if (!timer && !userTookOver) timer = setInterval(function () { show(i + 1); }, INTERVAL);
      }

      /* Swapping the photo out from under someone who has deliberately hovered to look at it is
         the single rudest thing this component did. */
      media.addEventListener('mouseenter', function () { if (!userTookOver) stop(); });
      media.addEventListener('mouseleave', function () { start(); });
      media.addEventListener('focusin', function () { stop(); });

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            start();
          } else {
            stop();
          }
        });
      }, { rootMargin: '0px', threshold: 0.4 });

      io.observe(media);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
